// src/components/icons/ShareIcon.js
import React from 'react';

const ShareIcon = () => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" className="share-icon">
    <title>Share</title>
    <g>
      <circle cx="12" cy="5" r="2"/>
      <circle cx="12" cy="15" r="2"/>
      <circle cx="4" cy="10" r="2"/>
      <path d="M 13,3 3,8 13,13" fill="none" stroke="currentColor" strokeWidth="1"/>
    </g>
  </svg>
);

export default ShareIcon;